import { useChatActivityTracking } from '../../../features/assistant/utils/tracking';
import { MessageList } from '../message/list';

import { UserInput } from './UserInput';
import styles from './styles.module.css';

interface ChatProps {}

const Chat: React.FC<ChatProps> = () => {
  const { trackDebouncedEvent } = useChatActivityTracking();

  const onInputChanged = (value: string) => {
    trackDebouncedEvent('input_changed', { input: value });
  };

  return (
    <div className={styles.chatContainer}>
      <MessageList />
      <UserInput onInputChanged={onInputChanged} />
    </div>
  );
};

export { Chat };
